/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Col_Created_AtInputs */

const vi_cdo_col_created_at = /** @type {(inputs: Cdo_Col_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

/**

* @param {Cdo_Col_Created_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_col_created_at = /** @type {((inputs?: Cdo_Col_Created_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Col_Created_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_col_created_at(inputs)
});